import { jsxs as e, jsx as r } from "react/jsx-runtime";
const n = ({ className: o, width: t = "19", height: C = "17" }) => /* @__PURE__ */ e(
  "svg",
  {
    className: o,
    width: t,
    height: C,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 17",
    fill: "none",
    children: [
      /* @__PURE__ */ r("rect", { x: "1", y: "1", width: "17", height: "15", rx: "2", stroke: "currentColor", strokeLinejoin: "round" }),
      /* @__PURE__ */ r("path", { d: "M5.85728 8.49916C5.85728 9.0909 5.31363 9.57059 4.643 9.57059C3.97237 9.57059 3.42871 9.0909 3.42871 8.49916C3.42871 7.90743 3.97237 7.42773 4.643 7.42773C5.31363 7.42773 5.85728 7.90743 5.85728 8.49916Z", fill: "currentColor" }),
      /* @__PURE__ */ r("path", { d: "M10.7144 8.49916C10.7144 9.0909 10.1708 9.57059 9.50014 9.57059C8.82951 9.57059 8.28585 9.0909 8.28585 8.49916C8.28585 7.90743 8.82951 7.42773 9.50014 7.42773C10.1708 7.42773 10.7144 7.90743 10.7144 8.49916Z", fill: "currentColor" }),
      /* @__PURE__ */ r("path", { d: "M14.3573 9.57059C15.0279 9.57059 15.5716 9.0909 15.5716 8.49916C15.5716 7.90743 15.0279 7.42773 14.3573 7.42773C13.6867 7.42773 13.143 7.90743 13.143 8.49916C13.143 9.0909 13.6867 9.57059 14.3573 9.57059Z", fill: "currentColor" })
    ]
  }
);
export {
  n as default
};
